import { I18n } from "@assets/strings";
import React from "react";
import { useSuggestedOrganizations } from "@domain/organization/hooks";
import { OrganizationThumbnail } from "@ui/pages/searchPage/organizationThumbnail";
import { Carousel } from "@ui/components/carousel/carousel";

type FeedOrganizationSuggestionsProps = React.HTMLAttributes<HTMLDivElement>;
export const FeedOrganizationSuggestions: React.FC<FeedOrganizationSuggestionsProps> = ({ ...htmlProps }) => {
	const { result: organizations, loading } = useSuggestedOrganizations(5);

	return (
		<Carousel
			{...htmlProps}
			style={{ marginTop: 20 }}
			items={organizations.filter((o) => !o.followedByMeSince) ?? []}
			renderItem={(org) => <OrganizationThumbnail small key={org.id} organization={org} />}
			title={I18n.t("feed.suggestions.organizations")}
			loading={loading}
		/>
	);
};
